<template>
  <div>
    <v-form v-model="isFormValid">
      <h2>会計設定</h2>

      <v-progress-linear v-if="isLoading" indeterminate />

      <v-container class="mt-4">
        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>月極保育料</h5>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="inputValue.monthlyNurseryTaxation"
              :items="taxationItems"
              :label="taxationLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.monthlyNurseryServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>月極保育料(差額)</h5>
          </v-col>
          <v-col cols="3"> </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.monthlyNurseryDiffServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>月極延長料</h5>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="inputValue.monthlyAdditionalNurseryTaxation"
              :items="taxationItems"
              :label="taxationLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.monthlyAdditionalNurseryServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>月極延長料(差額)</h5>
          </v-col>
          <v-col cols="3"> </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.monthlyAdditionalNurseryDiffServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>スポット保育料</h5>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="inputValue.spotNurseryTaxation"
              :items="taxationItems"
              :label="taxationLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.spotNurseryServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>スポット保育料(差額)</h5>
          </v-col>
          <v-col cols="3"> </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.spotNurseryDiffServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>主食代・補食代</h5>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="inputValue.nurseryFoodTaxation"
              :items="taxationItems"
              :label="taxationLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.nurseryFoodServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>主食代・補食代(差額)</h5>
          </v-col>
          <v-col cols="3"> </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.nurseryFoodDiffServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>園提供サービス</h5>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="inputValue.extraTaxation"
              :items="taxationItems"
              :label="taxationLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.extraServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="4">
            <h5>園提供サービス(差額)</h5>
          </v-col>
          <v-col cols="3"> </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="inputValue.extraDiffServiceCode"
              :label="serviceCodeLabel"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="9">
            <h5>税率</h5>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="taxRatePercent"
              placeholder="例) 8"
              variant="outlined"
              suffix="%"
              hide-details=""
              density="compact"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>

      <div class="d-flex justify-center mt-6">
        <v-btn
          @click="updateServiceSetting"
          :disabled="!isFormValid || isLoading"
          color="primary"
          depressed
          large
          >保存</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script lang="ts">
import { PutServiceSettingRequest } from "@/api/ApiCompany";
import ValidationMixin from "@/mixins/ValidationMixin";
import LocalDataService from "@/service/LocalDataService";
import { companyModule } from "@/store/dataModule/companyModule";
import { defineComponent } from "vue";
export default defineComponent({
  mixins: [ValidationMixin],

  async mounted() {
    await this.getServiceSetting();
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
      serviceCodeLabel: "商品コード",
      taxationLabel: "課税/非課税",
      taxationItems: [
        { title: "課税", value: true },
        { title: "非課税", value: false },
      ],
      inputValue: {} as PutServiceSettingRequest,
    };
  },

  computed: {
    taxRatePercent: {
      get(): number {
        return Number(this.inputValue.taxRate) * 100;
      },
      set(value: number) {
        this.inputValue.taxRate = Number(value) / 100;
      },
    },
  },

  methods: {
    async getServiceSetting() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        const response = await companyModule.getServiceSetting({
          companyId,
        });
        if (response) {
          this.inputValue = response as any;
        }
      }
      this.isLoading = false;
    },
    async updateServiceSetting() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        await companyModule.updateServiceSetting({
          companyId,
          ...this.inputValue,
        });
        await this.getServiceSetting();
      }
      this.isLoading = false;
    },
  },
});
</script>
